import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";

export default function CollapsibleCodeBlock({ content, language = "text" }) {
    // Ensure content is always a string and handle edge cases
    const safeContent = content != null ? String(content) : '';
    
    return (
        <div>
            <SyntaxHighlighter language={language} style={oneDark}>
                {safeContent}
            </SyntaxHighlighter>
        </div>
    );
};
